
import DataFolder from './DataFolder';
import Dropzone from '../../../vendor/dropzone';

export default class Menu {
    constructor(instance, type) {
        this.instance = instance;
        this.parentId = this.instance.id;
        this.type = type;
        this.permissions = this.instance.permissions;

        this.buildMenu();
    }

    buildMenu() {
        // add and position a general wrapper
        $('.menu-wrapper').remove();
        this.instance.$el.append('<div class="menu-wrapper"></div>');
        let $wrapper = this.instance.$el.find('.menu-wrapper');
        $wrapper.css("left", this.instance.$link.find('span').width() + 60);

        if ((this.type == 'folder' && this.permissions == 65543) || (this.type == 'file' && this.permissions == 65537)) {
            // show directly info button
            $('.menu-btn-infos').remove();

            // Permission: showinfos / share
            $wrapper.append('<button class="menu-btn-infos" title="Teilen" data-action="share"><svg class="gfx-share-alt-light"><use xlink:href="#share-alt-light"></use></svg></button>');
            let that = this;
            $('button[data-action="share"]').on('click', (e) => {
                let shareUrl = $('.mxm_securearea_next').data('shareurl');
                shareUrl = shareUrl.replace('##id##', this.parentId);
                let itemName = $('a[data-id="' + this.parentId + '"] span').text();

                $.confirm({
                    onOpen: that.onOpenConfirm,
                    onClose: that.onCloseConfirm,
                    columnClass: 'medium',
                    type: 'blue',
                    title: 'Link teilen',
                    content: '<p>Kopieren sie folgende URL um <strong>' + itemName + '</strong> zu teilen:</p><p><a target="_blank" href="' + shareUrl + '">' + shareUrl + '</a></p>',

                    buttons: {
                        btnOk: {
                            text: 'Schliessen',
                            keys: ['esc']
                        }
                    }
                });
            });

            $wrapper.append('<button class="menu-btn-infos" title="Informationen" data-action="showinfos"><svg class="gfx-ODA_ICONS_gesch.ber_infos_2-dims"><use xlink:href="#ODA_ICONS_gesch.ber_infos_2"></use></svg></button>');
            $('button[data-action="showinfos"]').on('click', (e) => {
                this.ajaxCall(this.showInfos, {
                    "action": dataActionPrefix + "showinfos",
                    "folderOrFileId": this.parentId
                }
                );

            });
        } else {
            // show menu button and icons on hover
            $wrapper.append('<button class="btn menu-btn"><svg class="gfx-ODA_ICONS_gesch.ber_menu_anzeigen_2-dims"><use xlink:href="#ODA_ICONS_gesch.ber_menu_anzeigen_2"></use></svg></button>');
            let $menubtn = $wrapper.find('.menu-btn');

            $menubtn.hover((e) => {
                $wrapper.addClass('show-menu');
                $('.menu-content').remove();
                $wrapper.append('<div class="menu-content"></div>');
                this.$menu = $('.menu-content');
                this.checkPermissions();
            });
        }
    }   

    checkPermissions() {
        if (this.type == 'file' && (this.permissions & 16) == 16) {
            // Permission: renamefile
            this.$menu.append('<button title="Umbenennen" data-action="renamefile"><svg class="gfx-ODA_ICONS_gesch.ber_bearbeiten-dims"><use xlink:href="#ODA_ICONS_gesch.ber_bearbeiten"></use></svg></button>');

            let that = this;
            $('button[data-action="renamefile"]').on('click', (e) => {
                let sourceFileTitle = $(e.target).closest('li').find('[data-type] > span').text();
                
                $.confirm({
                    onOpen: that.onOpenConfirm,
                    onClose: that.onCloseConfirm,
                    type: 'orange',
                    title: 'Datei umbenennen',
                    onContentReady: function() {
                        let confirmContent = this.$content;
                        confirmContent.find('input').prop('disabled', true);

                        let sourceFileName;

                        $.ajax({
                            type: "post",
                            dataType: "json",
                            url: dataUrl,
                            data: {
                                "action": dataActionPrefix + "getinfo",
                                "folderOrFileId": that.parentId
                            },
                            success: (json) => {
                                $('.errormsg').remove();
                                if (json.success) {
                                    confirmContent.find('.filetitle').prop('value', json.data.title);
                                    confirmContent.find('.filename').prop('value', json.data.filename);
                                    confirmContent.find('input').prop('disabled', false);
                                } else {
                                    securearea.showError(params.action, json);
                                    return false;
                                }
                            }
                        });
                    },
                    content: '' +
                        '<form action="">' +
                        '<div class="form-group">' +
                        '<label>Anzeigename:</label>' +
                        '<input type="text" class="filetitle form-control" required value="" />' +
                        '</div>' +
                        '<div class="form-group">' +
                        '<label>Dateiname:</label>' +
                        '<input type="text" class="filename form-control" required value="" />' +
                        '</div>' +
                        '</form>',
                    buttons: {
                        btnCancel: {
                            text: 'Abbrechen',
                            keys: ['esc']
                        },
                        btnRename: {
                            text: 'Umbenennen',
                            btnClass: 'btn-orange',
                            action: function() {
                                var fileTitle = this.$content.find('.filetitle').val();
                                var fileName = this.$content.find('.filename').val();
                                that.fileTitle = fileTitle;
                                if (fileTitle && fileName) {
                                    that.ajaxCall(that.renameFile, {
                                        "action": dataActionPrefix + "renamefile",
                                        "fileId": that.parentId,
                                        "fileTitle": fileTitle,
                                        "fileName": fileName,
                                    });
                                }
                                else {
                                    return false;
                                }
                            }
                        }
                    }
                });
            });
        }

        if (this.type == 'file' && (this.permissions & 32) == 32) {
            // Permission: movefile
            this.$menu.append('<button title="Verschieben" data-action="movefile"><svg class="gfx-ODA_ICONS_gesch.ber_verschieben-dims"><use xlink:href="#ODA_ICONS_gesch.ber_verschieben"></use></svg></button>');

            let that = this;
            $('button[data-action="movefile"]').on('click', (e) => {
                $.confirm({
                    onOpen: that.onOpenConfirm,
                    onClose: that.onCloseConfirm,
                    type: 'orange',
                    title: 'Datei verschieben',
                    columnClass: 'col-md-10 col-md-offset-1',
                    content: that.folderBrowserContent(),
                    onContentReady: function () {
                        that.initFolderBrowser(that, this.$content, this.buttons);
                    },
                    buttons: {
                        btnCancel: {
                            text: 'Abbrechen',
                            keys: ['esc']
                        },
                        btnYes: {
                            text: 'Verschieben',
                            btnClass: 'btn-orange',
                            action: function () {
                                var destinationFolder = this.$content.find('.secure_breadcrumb_ul li:last-child > a').data('id');
                                if (destinationFolder) {
                                    that.ajaxCall(that.moveFile, {
                                        "action": dataActionPrefix + "movefile",
                                        "fileId": that.parentId,
                                        "folderId": destinationFolder
                                    });
                                }
                            }
                        }
                    }
                });
            });
        }

        if (this.type == 'file' && (this.permissions & 64) == 64) {
            // Permission: deletefile
            this.$menu.append('<button title="Löschen" data-action="deletefile"><svg class="gfx-ODA_ICONS_gesch.ber_loeschen-dims"><use xlink:href="#ODA_ICONS_gesch.ber_loeschen"></use></svg></button>');
            let that = this;
            $('button[data-action="deletefile"]').on('click', (e) => {
                let filename = $('a[data-id="' + this.parentId + '"] span').text();

                $.confirm({
                    onOpen: that.onOpenConfirm,
                    onClose: that.onCloseConfirm,
                    type: 'orange',
                    title: 'Datei löschen',
                    content: '<p>Wollen Sie die Datei</p><p><strong>' + filename + '</strong></p><p>wirklich löschen?</p>',

                    buttons: {
                        btnNo: {
                            text: 'Abbrechen',
                            keys: ['esc']
                        },
                        btnYes: {
                            text: 'Löschen',
                            btnClass: 'btn-orange',
                            action: () => {
                                this.ajaxCall(this.deleteFile, {
                                    "action": dataActionPrefix + "deletefile",
                                    "fileId": this.parentId
                                });
                            }
                        }
                    }
                });
            });
        }

        if (this.type == 'file' && (this.permissions & 128) == 128) {
            // Permission: copyfile
            this.$menu.append('<button title="Kopieren" data-action="copyfile"><svg class="gfx-ODA_ICONS_gesch.ber_datei_kopieren-dims"><use xlink:href="#ODA_ICONS_gesch.ber_datei_kopieren"></use></svg></button>');

            let that = this;
            $('button[data-action="copyfile"]').on('click', (e) => {
                $.confirm({
                    onOpen: that.onOpenConfirm,
                    onClose: that.onCloseConfirm,
                    type: 'orange',
                    title: 'Datei kopieren',
                    columnClass: 'col-md-10 col-md-offset-1',
                    content: that.folderBrowserContent(),
                    onContentReady: function () {
                        that.initFolderBrowser(that, this.$content, this.buttons);
                    },
                    buttons: {
                        btnCancel: {
                            text: 'Abbrechen',
                            keys: ['esc']
                        },
                        btnYes: {
                            text: 'Kopieren',
                            btnClass: 'btn-orange',
                            action: function () {
                                var destinationFolder = this.$content.find('.secure_breadcrumb_ul li:last-child > a').data('id');
                                if (destinationFolder) {
                                    that.ajaxCall(that.copyFile, {
                                        "action": dataActionPrefix + "copyfile",
                                        "fileId": that.parentId,
                                        "folderId": destinationFolder
                                    });
                                }
                            }
                        }
                    }
                });
            });
        }

        if (this.type == 'file' && (this.permissions & 256) == 256) {
            // Permission: sortfile
            this.$menu.append('<button title="Nach oben verschieben" data-action="sortfile" data-direction="up"><svg class="gfx-ODA_ICONS_gesch.ber_1_oben-dims"><use xlink:href="#ODA_ICONS_gesch.ber_1_oben"></use></svg></button>');
            this.$menu.append('<button title="Nach unten verschieben" data-action="sortfile" data-direction="down"><svg class="gfx-ODA_ICONS_gesch.ber_1_unten-dims"><use xlink:href="#ODA_ICONS_gesch.ber_1_unten"></use></svg></button>');
            this.$menu.append('<button title="An den Anfang verschieben" data-action="sortfile" data-direction="top"><svg class="gfx-ODA_ICONS_gesch.ber_anfang-dims"><use xlink:href="#ODA_ICONS_gesch.ber_anfang"></use></svg></button>');
            this.$menu.append('<button title="An das Ende verschieben" data-action="sortfile" data-direction="bottom"><svg class="gfx-ODA_ICONS_gesch.ber_ende-dims"><use xlink:href="#ODA_ICONS_gesch.ber_ende"></use></svg></button>');

            $('button[data-action="sortfile"]').on('click', (e) => {
                let $target = $(e.target);
                if (!$target.is('button')) {
                    $target = $target.closest('button');
                }

                this.ajaxCall(this.sortFile, {
                    "action": dataActionPrefix + "sortfile",
                    "fileId": this.parentId,
                    "direction": $target.data('direction'),
                });

                this.sortdirection = $target.data('direction');
            });
        }

        if (this.type == 'file' && (this.permissions & 512) == 512) {
            // Permission: replacefile
            this.$menu.append('<button title="Ersetzen" data-action="replacefile"><svg class="gfx-ODA_ICONS_gesch.ber_datei_ersetzen-dims"><use xlink:href="#ODA_ICONS_gesch.ber_datei_ersetzen"></use></svg></button>');

            let that = this;
            $('button[data-action="replacefile"]').on('click', (e) => {
                $.confirm({
                    onOpen: that.onOpenConfirm,
                    onClose: that.onCloseConfirm,
                    onContentReady: function() {
                        let jc = this;

                        let $rpdropzone = new Dropzone('#drop_rp_' + that.parentId, {
                            url: dataUrl + "?action=" + dataActionPrefix + "replacefile&fileId=" + that.parentId,
                            clickable: true,
                            timeout: 300000,
                            maxFiles: 1,
                            uploadMultiple: false,
                            dictDefaultMessage: "Datei hierhin ziehen<br />oder<br />hier klicken um Dialog zu öffnen.",
                            thumbnailMethod: "contain",
                            previewTemplate: `<div class="dz-preview dropzone-preview">
                                <div class="filename">
                                    <span class="dropzone-success-mark"><i class="fa fa-check"></i></span><span class="dropzone-error-mark"><i class="fa fa-exclamation-triangle"></i></span>
                                    <span data-dz-name class=""></span>
                                </div>
                                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress=""></span></div>
                                <div class="error-msg"><span data-dz-errormessage><small>nicht hochgeladen</small></span></div>
                            </div>`,
                            accept: function (file, done) {
                                let extsplit = file.name.split('.');
                                let ext = extsplit[extsplit.length - 1].toLowerCase();
    
                                this.on("addedfile", function () {
                                    if (this.files[1] != null) {
                                        this.removeFile(this.files[0]);
                                    }
                                });
                                
                                if (allowedFileExtensions.search(ext) == -1) {
                                    file.errorMessage = "Die Datei <strong>" + file.name + "</strong> hat einen unerlaubten Dateityp.";
                                    done("Unerlaubter Typ.");
                                } else if (file.size > maxFileSize) {
                                    file.errorMessage = "Die Datei <strong>" + file.name + "</strong> ist zu schwer.";
                                    done("Unerlaubte Grösse.");
                                } else {
                                    done();
                                }
                            },
                            error: function (file) {
                                $(file.previewElement).addClass('dz-error');
                                let errormsg = "Der Server ist momentan nicht erreichbar. Bitte wenden Sie sich an den Administrator oder versuchen Sie es später nochmal.";
                                if (file.errorMessage) {
                                    errormsg = file.errorMessage;
                                }
                                let json = { success: false, errors: [errormsg], errorcode: 0, debug: ["Dropzone Error: wrong file size or dropzone error", errormsg] }
                                securearea.showError("replacefile", json);
                            },
                            success: function (dzresult, wpresult) {
                                $('.errormsg').remove();
    
                                if (wpresult.success) {
                                    $('.dropzone .btn[data-action="getfolder"]').addClass('show');
                                    jc.buttons.btnRename.enable();
                                } else {
                                    securearea.showError("replacefile", wpresult);
                                    return false;
                                }
                            }
                        });
                    },
                    type: 'orange',
                    title: 'Datei ersetzen',
                    content: '' +
                        '<div class="dropzone dropzone-single dropzone-theme" id="drop_rp_' + that.parentId + '"></div>',
                    buttons: {
                        btnCancel: {
                            text: 'Abbrechen',
                            keys: ['esc']
                        },
                        btnRename: {
                            text: 'Schliessen',
                            btnClass: 'btn-orange',
                            isDisabled: true,
                            action: function () {
                                return true;
                            }
                        }
                    }
                });
            });
        }

        if (this.type == 'folder' && (this.permissions & 1024) == 1024) {
            // Permission: createfolder
            this.$menu.append('<button title="Ordner erstellen" data-action="createfolder"><svg class="gfx-ODA_ICONS_gesch.ber_erstellen-dims"><use xlink:href="#ODA_ICONS_gesch.ber_erstellen"></use></svg></button>');

            let that = this;
            $('button[data-action="createfolder"]').on('click', (e) => {

                $.confirm({
                    onOpen: that.onOpenConfirm,
                    onClose: that.onCloseConfirm,
                    type: 'orange',
                    title: 'Ordner erstellen',
                    content: '' +
                        '<form action="">' +
                        '<div class="form-group">' +
                        '<label>Anzeigename:</label>' +
                        '<input type="text" class="foldername form-control" required />' +
                        '</div>' +
                        '</form>',
                    buttons: {
                        btnCancel: {
                            text: 'Abbrechen',
                            keys: ['esc']
                        },
                        btnRename: {
                            text: 'Erstellen',
                            btnClass: 'btn-orange',
                            action: function () {
                                var folderName = this.$content.find('.foldername').val();
                                that.folderName = folderName;
                                if (folderName) {
                                    that.ajaxCall(that.createFolder, {
                                        "action": dataActionPrefix + "createfolder",
                                        "folderId": that.parentId,
                                        "folderName": folderName,
                                    });
                                }
                                else {
                                    return false;
                                }
                            }
                        }
                    }
                });
            });
        }

        if (this.type == 'folder' && (this.permissions & 2048) == 2048) {
            // Permission: renamefolder
            this.$menu.append('<button title="Umbenennen" data-action="renamefolder"><svg class="gfx-ODA_ICONS_gesch.ber_bearbeiten-dims"><use xlink:href="#ODA_ICONS_gesch.ber_bearbeiten"></use></svg>/button>');

            let that = this;
            $('button[data-action="renamefolder"]').on('click', (e) => {
                let targetText = $(e.target).closest('li').find('[data-type] > span').first().text();

                $.confirm({
                    onOpen: that.onOpenConfirm,
                    onClose: that.onCloseConfirm,
                    type: 'orange',
                    title: 'Ordner umbenennen',
                    content: '' +
                        '<form action="">' +
                        '<div class="form-group">' +
                        '<label>Anzeigename:</label>' +
                        '<input type="text" class="foldername form-control" value="' + targetText + '" required />' +
                        '</div>' +
                        '</form>',

                    buttons: {
                        btnCancel: {
                            text: 'Abbrechen',
                            keys: ['esc']
                        },
                        btnRename: {
                            text: 'Umbenennen',
                            btnClass: 'btn-orange',
                            action: function () {
                                var foldername = this.$content.find('.foldername').val();
                                that.foldername = foldername;
                                if (foldername) {
                                    that.ajaxCall(that.renameFolder, {
                                        "action": dataActionPrefix + "renamefolder",
                                        "folderId": that.parentId,
                                        "folderName": foldername,
                                    });
                                }
                                else {
                                    return false;
                                }
                            }
                        }
                    }
                });
            });
        }

        if (this.type == 'folder' && (this.permissions & 4096) == 4096) {
            // Permission: movefolder
            this.$menu.append('<button title="Verschieben" data-action="movefolder"><svg class="gfx-ODA_ICONS_gesch.ber_verschieben-dims"><use xlink:href="#ODA_ICONS_gesch.ber_verschieben"></use></svg></button>');

             let that = this;
             $('button[data-action="movefolder"]').on('click', (e) => {
                 $.confirm({
                     onOpen: that.onOpenConfirm,
                     onClose: that.onCloseConfirm,
                     type: 'orange',
                     title: 'Ordner verschieben',
                     columnClass: 'col-md-10 col-md-offset-1',
                     content: that.folderBrowserContent(),
                     onContentReady: function () {
                         that.initFolderBrowser(that, this.$content, this.buttons);
                     },
                     buttons: {
                         btnCancel: {
                             text: 'Abbrechen',
                             keys: ['esc']
                         },
                         btnYes: {
                             text: 'Verschieben',
                             btnClass: 'btn-orange',
                             action: function () {
                                 var destinationFolder = this.$content.find('.secure_breadcrumb_ul li:last-child > a').data('id');
                                 if (destinationFolder) {
                                     that.ajaxCall(that.moveFolder, {
                                         "action": dataActionPrefix + "movefolder",
                                         "folderId": that.parentId,
                                         "destinationFolderId": destinationFolder
                                     });
                                 }
                             }
                         }
                     }
                 });
             });
        }

        if (this.type == 'folder' && (this.permissions & 8192) == 8192) {
            // Permission: deletefolder
            this.$menu.append('<button title="Löschen" data-action="deletefolder"><svg class="gfx-ODA_ICONS_gesch.ber_loeschen-dims"><use xlink:href="#ODA_ICONS_gesch.ber_loeschen"></use></svg>/button>');
            let that = this;
            $('button[data-action="deletefolder"]').on('click', (e) => {
                let foldername = $('a[data-id="'+this.parentId+'"] span').text();

                $.confirm({
                    onOpen: that.onOpenConfirm,
                    onClose: that.onCloseConfirm,
                    type: 'orange',
                    title: 'Datei löschen',
                    content: '<p>Wollen Sie den Ordner</p><p><strong>'+foldername+'</strong></p><p>wirklich löschen?</p>',

                    buttons: {
                        btnNo: {
                            text: 'Abbrechen',
                            keys: ['esc']
                        },
                        btnYes: {
                            text: 'Löschen',
                            btnClass: 'btn-orange',
                            action: () => {
                                this.ajaxCall(this.deleteFolder, {
                                    "action": dataActionPrefix + "deletefolder",
                                    "folderId": this.parentId
                                });
                            }
                        }
                    }
                });
            });
        }

        if (this.type == 'folder' && (this.permissions & 131072) == 131072) {
            // Permission: deleteFiles
            this.$menu.append('<button title="Alle Dateien löschen" data-action="deletefiles"><svg class="gfx-ODA_ICONS_gesch.ber_alle_dateien_loeschen-dims"><use xlink:href="#ODA_ICONS_gesch.ber_alle_dateien_loeschen"></use></svg></button>');
            
            let that = this;
            $('button[data-action="deletefiles"]').on('click', (e) => {
                let foldername = $('a[data-id="' + this.parentId + '"] span').text();

                $.confirm({
                    onOpen: that.onOpenConfirm,
                    onClose: that.onCloseConfirm,
                    type: 'orange',
                    title: 'Dateien löschen',
                    content: '<p>Wollen Sie alle Dateien aus dem Ordner</p><p><strong>' + foldername + '</strong></p><p>löschen?</p>',

                    buttons: {
                        btnNo: {
                            text: 'Abbrechen',
                            keys: ['esc']
                        },
                        btnYes: {
                            text: 'Alle Löschen',
                            btnClass: 'btn-orange',
                            action: function() {
                                that.ajaxCall(that.deleteFiles, {
                                    "action": dataActionPrefix + "deletefiles",
                                    "folderId": that.parentId
                                });
                            }
                        }
                    }
                });
            });
        }

        if (this.type == 'folder' && (this.permissions & 16384) == 16384) {
            // Permission: copyfolder
            this.$menu.append('<button title="Kopieren" data-action="copyfolder"><svg class="gfx-ODA_ICONS_gesch.ber_ordner_kopieren-dims"><use xlink:href="#ODA_ICONS_gesch.ber_ordner_kopieren"></use></svg></button>');

            let that = this;
            $('button[data-action="copyfolder"]').on('click', (e) => {
                $.confirm({
                    onOpen: that.onOpenConfirm,
                    onClose: that.onCloseConfirm,
                    type: 'orange',
                    title: 'Ordner kopieren',
                    columnClass: 'col-md-10 col-md-offset-1',
                    content: that.folderBrowserContent(),
                    onContentReady: function () {  
                        that.initFolderBrowser(that, this.$content, this.buttons);   
                    },
                    buttons: {
                        btnCancel: {
                            text: 'Abbrechen',
                            keys: ['esc']
                        },
                        btnYes: {
                            text: 'Kopieren',
                            btnClass: 'btn-orange',
                            action: function() {
                                var destinationFolder = this.$content.find('.secure_breadcrumb_ul li:last-child > a').data('id');
                                if (destinationFolder) {
                                    that.ajaxCall(that.copyFolder, {
                                        "action": dataActionPrefix + "copyfolder",
                                        "folderId": that.parentId,
                                        "destinationFolderId": destinationFolder
                                    });
                                }
                            }
                        }
                    }
                });
            });
        }

        if (this.type == 'folder' && (this.permissions & 32768) == 32768) {
            // Permission: sortfolder
            this.$menu.append('<button title="Nach oben verschieben" data-action="sortfolder" data-direction="up"><svg class="gfx-ODA_ICONS_gesch.ber_1_oben-dims"><use xlink:href="#ODA_ICONS_gesch.ber_1_oben"></use></svg></button>');
            this.$menu.append('<button title="Nach unten verschiebe" data-action="sortfolder" data-direction="down"><svg class="gfx-ODA_ICONS_gesch.ber_1_unten-dims"><use xlink:href="#ODA_ICONS_gesch.ber_1_unten"></use></svg></button>');
            this.$menu.append('<button title="An den Anfang verschieben" data-action="sortfolder" data-direction="top"><svg class="gfx-ODA_ICONS_gesch.ber_anfang-dims"><use xlink:href="#ODA_ICONS_gesch.ber_anfang"></use></svg></i></button>');
            this.$menu.append('<button title="An das Ende verschieben" data-action="sortfolder" data-direction="bottom"><svg class="gfx-ODA_ICONS_gesch.ber_ende-dims"><use xlink:href="#ODA_ICONS_gesch.ber_ende"></use></svg></i></button>');
            $('button[data-action="sortfolder"]').on('click', (e) => {
                let $target = $(e.target);
                if (!$target.is('button')) {
                    $target = $target.closest('button');
                }

                this.ajaxCall(this.sortFolder, {
                    "action": dataActionPrefix + "sortfolder",
                    "folderId": this.parentId,
                    "direction": $target.data('direction'),
                });

                this.sortdirection = $target.data('direction');
            });
        }

        if ((this.permissions & 1) == 1) {
            // Permission: showinfos / share
            this.$menu.append('<button title="Teilen" data-action="share"><svg class="gfx-share-alt-light"><use xlink:href="#share-alt-light"></use></svg></button>');
            let that = this;
            $('button[data-action="share"]').on('click', (e) => {
                let shareUrl = $('.mxm_securearea_next').data('shareurl');
                shareUrl = shareUrl.replace('##id##', this.parentId);
                let itemName = $('a[data-id="' + this.parentId + '"] span').text();

                $.confirm({
                    onOpen: that.onOpenConfirm,
                    onClose: that.onCloseConfirm,
                    columnClass: 'medium',
                    type: 'blue',
                    title: 'Link teilen',
                    content: '<p>Kopieren sie folgende URL um <strong>' + itemName + '</strong> zu teilen:</p><p><a target="_blank" href="' + shareUrl + '">' + shareUrl + '</a></p>',

                    buttons: {
                        btnOk: {
                            text: 'Schliessen',
                            keys: ['esc']
                        }
                    }
                });
            });
        }

        if ((this.permissions & 65536) == 65536) {
            // Permission: showinfos
            this.$menu.append('<button title="Informationen" data-action="showinfos"><svg class="gfx-ODA_ICONS_gesch.ber_infos_2-dims"><use xlink:href="#ODA_ICONS_gesch.ber_infos_2"></use></svg></button>');

            $('button[data-action="showinfos"]').on('click', (e) => {
                this.ajaxCall(this.showInfos, { 
                    "action": dataActionPrefix + "showinfos", 
                    "folderOrFileId": this.parentId}
                );
            });
        }
    }

    ajaxCall(callback, params) {
        $.ajax({
            type: "post",
            dataType: "json",
            url: dataUrl,
            data: params,
            beforeSend: () => {
                securearea.addSpinner();
            },
            complete: () => {
                securearea.removeSpinner();
            },
            success: (json) => {
                $('.errormsg').remove();
                if (json.success) {
                    callback(this, json.data, params);
                } else {
                    securearea.showError(params.action, json);
                    return false;
                }
            },
            error: function() {
            }
        });
    }


    showInfos(menu, data) {
        let $html = "";
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                $html += '<tr><th>' + key + '</th>';
                $html += '<td>';
                if (data[key] !== null && typeof data[key] === 'object') {
                    if (Array.isArray(data[key])) {
                        let tmpStr = data[key].join(', ');
                        $html += tmpStr;
                    } else {
                        for (const tdobj in data[key]) {
                            if (data[key].hasOwnProperty(tdobj)) {
                                const element = data[key][tdobj];
                                $html += '<i>'+tdobj+': </i>';
                                if (Array.isArray(element)) {
                                    $html += element.join(', ');
                                } else {
                                    $html += element;
                                }
                                $html += "<br />";                                
                            }
                        }
                    }
                } else {
                    $html += data[key];
                }
                $html += '</td>';
                $html += '</tr>';
            }
        }
        
        $.confirm({
            onOpen: menu.onOpenConfirm,
            onClose: menu.onCloseConfirm,
            backgroundDismiss: true,
            type: 'blue',
            title: 'Informationen',
            columnClass: 'col-md-10 col-md-offset-1',
            content: '' + '<table class="infotable">' + $html + '</table>',
            buttons: {
                btnOk: {
                    text: 'Schliessen',
                    keys: ['esc']
                }
            }
        });
    }

    moveFolder(menu, data, params) {
        menu.targetFolderRefresh(params.destinationFolderId);

        let parentfolders = $('a[data-id="' + menu.instance.id + '"]').closest('.folders').siblings('[data-type="folder"]');
        if (parentfolders.length) {
            menu.targetFolderRefresh($(parentfolders[0]).data('id'));
        }
    }

    moveFile(menu, data, params) {
        menu.targetFolderRefresh(params.folderId);

        let parentfolders = $('a[data-id="' + menu.instance.id + '"]').closest('.files').siblings('[data-type="folder"]');
        if (parentfolders.length) {
            menu.targetFolderRefresh($(parentfolders[0]).data('id'));
        }
    }
    
    copyFolder(menu, data, params) {
        menu.targetFolderRefresh(params.destinationFolderId);
    }

    folderBrowserContent() {
        return '' +
            '<div class="progress"><div class="indeterminate"></div></div>' +
            '<div class="secure_breadcrumb">' +
            '<a href="#" data-target="root"><i class="fa fa-home"></i></a>' +
            '<ul class="secure_breadcrumb_ul"></ul>' +
            '</div>' +
            '<div class="secure_folderbrowser">' +
            '<ul></ul>' +
            '</div>';
    }

    initFolderBrowser(that, confirmContent, buttons) {
        let spinner = confirmContent.find('.progress');
        let browserul = confirmContent.find('.secure_folderbrowser > ul');
        let breadcrumbList = confirmContent.find('.secure_breadcrumb_ul');
        let folderId = that.parentId;
        let moveUp = (that.type == 'file') ? false : true;
        let currentfolder;
        if (that.type == 'file') {
            currentfolder = $('a[data-id="' + that.parentId + '"]').closest('.files').siblings('[data-type="folder"]');
        } else {
            currentfolder = $('a[data-id="' + that.parentId + '"]');
        }

        let sourceFolderId = currentfolder.data('id');

        folderNavigation();

        confirmContent.click('[data-target]', function (e) {
            var target = $(e.target);

            if (!target.data('target') || target.data('target') == undefined) {
                if (target.closest('[data-target]').length > 0) {
                    target = target.closest('[data-target]');
                } else {
                    return;
                }
            }

            target.addClass('disabled');
            e.preventDefault();
            currentfolder = target;
            folderNavigation();
        });

        function folderNavigation() {
            if (!currentfolder.data('id') || currentfolder.data('id') == undefined) {
                currentfolder = currentfolder.closest('[data-target]');
            }

            let root = (currentfolder.data('target') == 'root');

            if (!moveUp) {
                folderId = currentfolder.data('id');
            }

            if (root) {
                folderId = 0;
            }

            $.ajax({
                type: "post",
                dataType: "json",
                url: dataUrl,
                data: {
                    "action": dataActionPrefix + "foldernavigation",
                    "folderId": folderId,
                    "sourceFolderId": sourceFolderId,
                    "moveUp": (moveUp) ? 1 : 0
                },
                beforeSend: () => {
                    spinner.addClass('showing');
                },
                complete: () => {
                    spinner.removeClass('showing');
                },
                success: (json) => {
                    if (json.success) {
                        // disable or enable buttons
                        if (that.type == 'file' && json.data.isCurrentFolder) {
                            buttons.btnYes.disable();
                        } else if (that.type == 'folder' && (json.data.isSubFolder || json.data.isCurrentFolder)) {
                            buttons.btnYes.disable();
                        } else {
                            buttons.btnYes.enable();
                        }

                        // fill folders
                        browserul.empty();
                        if (json.data.folders == null || json.data.folders.length == 0) {
                            browserul.append('<p class="noentries">Keine Einträge gefunden.</p>');
                        } else {
                            for (let i = 0; i < json.data.folders.length; i++) {
                                const element = json.data.folders[i];
                                let hasPermissions = (element.permissions & 1024) == 1024;
                                let isTarget = (element.id == folderId);
                                let isDisabled = (!hasPermissions || isTarget);
                                browserul.append('<li><a href="#"' + ' data-target="' + element.id + '" data-id="' + element.id + '">' + element.title + '</a></li>');
                            }
                        }

                        // fill breadcrumb
                        breadcrumbList.empty();
                        if (json.data.breadcrumbdots) {
                            breadcrumbList.append('<li>&hellip;</li>')
                        }
                        if (json.data.breadcrumb != null || json.data.breadcrumb.length != 0) {
                            for (let i = 0; i < json.data.breadcrumb.length; i++) {
                                const element = json.data.breadcrumb[i];
                                breadcrumbList.append('<li><a href="#" data-target="' + element.id + '" data-id="' + element.id + '">' + element.title + '</a></li>');
                            }
                        }

                        // other
                        moveUp = false;
                    } else {
                        securearea.showError("foldernavigation", json);
                        return false;
                    }
                }
            });
        }
    }
    
    copyFile(menu, data, params) {
        menu.targetFolderRefresh(params.folderId);
    }
    
    deleteFile(menu, data) {
        $('a[data-id="'+menu.parentId+'"]').closest('li').remove();
    }
    
    deleteFolder(menu, data) {
        $('a[data-id="'+menu.parentId+'"]').closest('li').remove();
    }

    deleteFiles(menu, data) {
        menu.instance.refreshFolder();
        menu.instance.refreshPermissions();
    }

    renameFile(menu, data) {
        $('a[data-id="' + menu.parentId + '"] span').text(menu.fileTitle);
    }

    renameFolder(menu, data) {
        $('a[data-id="' + menu.parentId + '"] span').text(menu.foldername);
    }

    createFolder(menu, data) {
        menu.instance.refreshFolder();
    }

    replaceFile(menu, data) {
        menu.instance.refreshFolder();
    }
    
    sortFolder(menu, data) {
        menu.sortEntry(menu);
    }
    
    sortFile(menu, data) {
        menu.sortEntry(menu);
    }

    sortEntry(menu) {
        let entry = menu.$menu.closest('li');

        switch (menu.sortdirection) {
            case 'up':
                entry.prev().insertAfter(entry);
                break;
            case 'down':
                entry.next().insertBefore(entry);
                break;
            case 'top':
                entry.closest('ul').prepend(entry);
                break;
                case 'bottom':
                entry.closest('ul').append(entry);
                break;

            default:
                break;
        }
    }

    onOpenConfirm() {
        document.body.style.overflow = "hidden";
    }
    
    onCloseConfirm() {
        document.body.style.overflow = "visible";
    }

    targetFolderRefresh(targetId) {
        let folder = $('[data-id="' + targetId + '"]');

        if (folder && folder.length) {
            let targetfolder = new DataFolder(
                {
                    id: targetId,
                    title: "",
                    permissions: "65543"
                },
                $('[data-id="' + targetId + '"]').closest('ul')
            );
            targetfolder.$el = $('[data-id="' + targetId + '"]').closest('li');
            targetfolder.refreshFolder();
        } else {
            console.log('no such folder ' + targetId);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/securearea-next/classes/Menu.js
 **/